// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_ListBulkOperationsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for list_bulk_operations endpoint
 * Returns paginated list of bulk message scheduling operations
 */
import type { MensagensProgramadasLote_BuscarMensagemProgramadaLoteRow } from './MensagensProgramadasLote_BuscarMensagemProgramadaLoteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MensagensProgramadasLote_ListBulkOperationsResponseDados {
operations: MensagensProgramadasLote_BuscarMensagemProgramadaLoteRow[]
total_count: number
limit: number
offset: number
}

export type MensagensProgramadasLote_ListBulkOperationsResponse = ApiResponse<MensagensProgramadasLote_ListBulkOperationsResponseDados>;

registerResponseContract('MensagensProgramadasLote_ListBulkOperationsResponse', {
  operations: {
    type: 'array',
    required: true,
    items: {
      id:                  { type: 'number',  required: true },
      periodo_inicio:      { type: 'string',  required: true },
      periodo_fim:         { type: 'string',  required: true },
      franquias:           { type: 'array',   required: false },
      template_id:         { type: 'number',  required: true },
      quantidade_clientes: { type: 'number',  required: true },
      customers_data:      { type: 'object',  required: false },
      mensagens_agendadas: { type: 'number',  required: false },
      mensagens_com_erro:  { type: 'number',  required: false },
      status:              { type: 'string',  required: true },
      data_criacao:        { type: 'string',  required: true },
      data_atualizacao:    { type: 'string',  required: false },
      usuario_id:          { type: 'number',  required: false },
      group_id:            { type: 'string',  required: false },
    },
  },
  total_count: { type: 'number',  required: true },
  limit:       { type: 'number',  required: true },
  offset:      { type: 'number',  required: true },
})
